<template>
  <transition name="fade" appear>
    <section>
      <svg width="0" height="0" style="position: absolute">
        <defs>
          <clipPath id="planTypeFirst" clipPathUnits="objectBoundingBox">
            <path
              d="M0.895,0 H0 C0.023,0.006,0.068,0.03,0.068,0.085 V0.895 C0.067,0.921,0.083,1,0.187,1 H1 V0.093 C1,0.015,0.93,-0.001,0.895,0"
            />
          </clipPath>
          <clipPath id="planType" clipPathUnits="objectBoundingBox">
            <path
              d="M0.895,0 H0 C0.023,0.006,0.068,0.03,0.068,0.085 V1 H1 V0.093 C1,0.015,0.93,-0.001,0.895,0"
            />
          </clipPath>
        </defs>
      </svg>
      <PageTitles
        :h1="$store.state.heading[props.type]"
        :h2="$store.state.cta[props.type]"
      />
      <div class="ui" :date-id="styleNames[props.type]">
        <PlanType
          v-for="(plan, id) in $store.state.plans[
            $store.state.plans.findIndex(
              (element) => element.FullTitle === styleNames[props.type]
            )
          ]?.Types"
          :per="
            props.type === 'multi-game-plans' && plan.Title !== 'Stadium Pass'
              ? 'Per Month'
              : 'Per Game'
          "
          :hasDisclaimer="props.type === 'multi-game-plans'"
          to="Home"
          :key="plan.Title"
          :date="plan.LaunchDate"
          :first="id === 0"
          :image="plan.Image.path"
          :icon="plan.Icon.path"
          :title="plan.Title"
          :description="plan.Description"
          :starting="plan.StartingFrom"
          :link="plan.Link"
        />
      </div>
    </section>
  </transition>
  <p class="disclaimer" v-if=" props.type === 'multi-game-plans'">
    *Pricing per month based off monthly payment plan. Pricing per month may
    vary depending on date of purchase.
  </p>
</template>
<script setup>
import PageTitles from "@/components/PageTitles";
import PlanType from "@/components/PlanType";
const props = defineProps({
  type: String,
});
const styleNames = {
  single: "Single Game Tickets",
  "large-group": "Large Group Tickets",
  "group-tickets-info": "Group Tickets Info",
  "multi-game-plans": "Multi-Game Plans",
};
</script>
<style lang="scss" scoped>
.disclaimer {
  padding: 15px 0;
  padding-left: 25px;
  margin: 0;
  color: #fff;
  margin: 0 auto;
  max-width: 375px;
  @media (min-width: 1075px) {
    padding-left: 15px;
    max-width: 1100px;
  }
}
section {
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
}
.ui {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 0;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  > * {
    //flex-grow: 1;
    :deep() a {
      margin: 0 auto;
    }
  }
  @media (min-width: 1200px) {
    flex-direction: row;
  }
}
</style>